<template>
	<div class="word_read">
		<router-view :key="$route.fullPath"></router-view>
	</div>
</template>
<script>
export default {
	data() {
		return {};
	},
	computed: {},
	watch: {},
	methods: {},
	created() {

	},
	mounted() {
	},
};
</script>
<style lang="less" scoped>
.word_read {
	display: flex;
	width: 100%;
	height: 100%;
}
</style>
